export const environment = {
  production: true,
  urlApiEndPointV3: 'https://apiformulafarma.healthfinder.es/',
  portalRole: 0,
  storagePrefix: 'front-farmacias-arias'
};
